import mss from "../images/mss.webp";
import pennymac from "../images/pennymac.webp";
import thelongevity from "../images/thelongevity.png";
import davtomp4 from "../images/davtomp4.png";
import fylo from "../images/fylo.png";
import spinvid from "../images/spinvid.png";
import shoppymall from "../images/shoppymall.png";
const PortfolioUtils = {
  portfolios: [
    {
      name: "Multi SMS Sender",
      android:
        "https://play.google.com/store/apps/details?id=crazy.pradeep.multismssender",
      ios: "",
      description:
        "Multi SMS Sender (MSS) application is used to send one message to multiple users at the same time. In which send a message to unlimited users by their message plan.",
      tech: [
        "Java",
        "Android",
        "Firestore",
        "Crashlytics",
        "Messages API",
        "Telephony Services",
      ],
      img: mss,
    },
       {
      name: "PENNYMAC MOBILE",
      android:
        "https://play.google.com/store/apps/details?id=com.pennymac.app&hl=en_US",
      ios: "https://apps.apple.com/us/app/pennymac-mobile/id1349950272",
      description:
        "It simple to manage your home loan, with everything you need at your fingertips.",
      tech: [
        "React Native",
        "Java",
        "Android",
        "Firebase",
        "Objective-C",
        "Crashlytics"
      ],
      img: pennymac,
    },
    {
      name: "FYLO – Your life in your pocket",
      android: "https://play.google.com/store/apps/details?id=com.fylo",
      ios: "https://apps.apple.com/us/app/fylo/id1494431826?ign-itscg=30200&ign-itsct=apps_box_link",
      description:
        "With Fylo you can stay on top of your finances, keep all of your bills and your budgets together, never forget a due date and automatically work out running costs of everything from your home to your holiday. You can get completely organised, keeping copies of policies, passwords and paperwork in your pocket.",
      tech: [
        "React Native",
        "Java",
        "Objective C",
        "Firestore",
        "Crashlytics",
        "Cloud Services",
        "Push Notification",
        "Encryption & Decryption",
        "Keychain",
      ],
      img: fylo,
    },
    {
      name: "SpinVid",
      android: "https://play.google.com/store/apps/details?id=com.spinvid",
      ios: "",
      description:
        "CREATED FOR THE MUSIC INDUSTRY, Through our passion for music and our creative drive, SpinVid has been created for artists, labels and music fans from every corner of the world and from all walks of life to share the music they make,release, listen to and love. TAKING VINYL INTO THE DIGITAL AGE",
      tech: [
        "Kotlin",
        "Android",
        "FFmpeg",
        "Firestore",
        "Crashlytics",
        "In-app Subscription",
      ],
      img: spinvid,
    },
    {
      name: "Shoppy Mall",
      android:
        "https://play.google.com/store/apps/details?id=com.dotsquares.shoppymall",
      ios: "",
      description:
        "The Shoppy Mall app lets you access and manages your Shopify store on your Android device. It provides categories view, product listing and product details view.",
      tech: [
        "React Native",
        "Java",
        "GraphQL",
        "Firestore",
        "Crashlytics",
        "Push Notification",
        "Objective C",
      ],
      img: shoppymall,
    },
    {
      name: "The Longevity Club (TLC)",
      android:
        "https://play.google.com/store/apps/details?id=com.thelongevityclub",
      ios: "",
      description:
        "The Longevity Club (TLC) is a “Wellness Club” that offers its club members services at cost without earning any profits.",
      tech: [
        "React Native",
        "Java",
        "Razorpay Payment",
        "Paytm Payment",
        "Firestore",
        "Crashlytics",
        "Push Notification",
        "Objective C",
      ],
      img: thelongevity,
    },
    {
      name: "Dav To MP4 ",
      android:
        "https://play.google.com/store/apps/details?id=crazy.pradeep.davtomp4",
      ios: "",
      description:
        "This app is really a cool tool to convert DAV file into MP4 format. You can easily convert DAV file to MP4 format without any limitation of the video.",
      tech: ["Kotlin", "Android", "FFmpeg", "Firestore", "Crashlytics"],
      img: davtomp4,
    },
  ],
};
export default PortfolioUtils;
